import { Injectable } from '@angular/core';
import { Country, IAuthData, IAuthResponseAPI, IResponseMessage, State } from '../../models';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiConstants } from '../../common';

@Injectable({
  providedIn: 'root',
})
export class CommonService {

  showSpinner: boolean = false;

  constructor(private http: HttpClient){

  }

  //AUTHENTICATION API FOR LOGIN
  authenticate(authData: IAuthData): Observable<IAuthResponseAPI> {
    return this.http.post<IAuthResponseAPI>(ApiConstants.superAdminLogin, authData);
  }

  //CLEAR TOKEN API FOR LOGOUT
  clearToken(): Observable<IResponseMessage> {
    return this.http.get<IResponseMessage>(ApiConstants.superAdminClearToken);
  }

  //API TO FETCH ALL COUNTRIES
  getCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(`${ApiConstants.countryStateApi}`);
  }

  //API TO FETCH ALL STATES BY COUNTRY
  getStates(countryId: string): Observable<State[]> {
    return this.http.get<State[]>(`${ApiConstants.countryStateApi}?country_id=${countryId}`);
  }

}
